module.exports = __webpack_public_path__ + "static/media/admin-stats.c52d578a.png";